import { render } from "./BigTermsMacOSSimple.vue?vue&type=template&id=51628a59&scoped=true"
import script from "./BigTermsMacOSSimple.vue?vue&type=script&lang=js"
export * from "./BigTermsMacOSSimple.vue?vue&type=script&lang=js"

import "./BigTermsMacOSSimple.vue?vue&type=style&index=0&id=51628a59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51628a59"]])

export default __exports__